import styled, { css } from 'styled-components';
import { Chip } from 'react-rainbow-components';
import Button from 'components/Button';
import Drawer from 'components/Drawer';
import Picklist from 'components/Picklist';
import { color } from 'theme';
import {
    DIVIDER, GREY_100, GREY_300, GREY_800,
} from '../../constants';

export const ValueContainer = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    outline: none;
    cursor: pointer;

    &:hover,
    &:focus {
        outline: 0;
    }
`;

export const InnerContainer = styled.div`
    position: relative;
    display: flex;
    width: 100%;
`;

export const StyledChip = styled(Chip)<{ $disabled?: boolean; $compact?: boolean }>`
    background-color: ${color('background.main')};
    padding: 0.4375rem 0.625rem 0.4375rem 0.75rem;
    align-items: center;
    gap: 0.5rem;
    flex: 1 1 auto;
    height: 3.375rem;
    border-radius: 1rem;

    & > button[data-id="button-icon-element"] {
        margin-right: -0.3rem;
        border-radius: 0.375rem;

        &:hover {
            margin-right: -0.3rem;
            border-radius: 0.375rem;
        }
    }

    ${(props) => props.$disabled && css`
        background-color: ${GREY_100};
        cursor: default;
    `};

    ${(props) => props.$compact && css`
        height: 2.5rem;
        min-width: 0;
        padding: 0 0.5rem 0 0.625rem;
        border: 1px solid ${DIVIDER};
        border-radius: 0.375rem;
        box-sizing: border-box;

        > span {
            min-width: 0;
            overflow: hidden;
        }
    `};
`;

export const CompactValue = styled.div`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    min-width: 0;
    overflow: hidden;
`;

export const CompactName = styled.span`
    flex: 1;
    min-width: 0;
    font-size: 0.875rem;
    font-weight: 500;
    line-height: 1.25rem;
    color: ${GREY_800};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const CompactPhone = styled.span`
    font-size: 0.8125rem;
    font-weight: 300;
    line-height: 1.25rem;
    color: ${GREY_300};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex-shrink: 0;
`;

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
    flex: 1;
    position: relative;
`;

export const StyledPicklist = styled(Picklist)`
    align-self: stretch;
`;

export const StyledButton = styled(Button)<{ hasError?: boolean }>`
    align-self: flex-end;
    ${(props) => props.hasError && css`
        position: absolute;
        bottom: -4px;
    `};
`;

export const StyledDrawer = styled(Drawer)`
    width: 400px;

    div[id^=drawer-content] {
        padding: 0;
    }
`;
